import { BasicPermissionItem } from '../../PermissionItem'
import {
  CreateViewEditSoftRemoveRestore,
  Revert,
  Simple,
  Unlock,
} from '../../common'
import { FDCTracker } from '../../../cimsPage/instances/fdc'

const page = FDCTracker
const object = 'Field Design Change'

const fdc = CreateViewEditSoftRemoveRestore({
  page,
  object,
  view: '0650231b-dac6-41c2-9642-57ff6c7500e6',
  create: '9ff948cd-3433-4987-903c-70d99114544a',
  edit: '691c4591-cfe9-4a4f-8e3f-0888aef7b9de',
  removeRestore: '1184de7f-1524-4b0e-800c-8854fb8cd03b',
})

export const ViewFieldDesignChange = fdc.View
export const CreateFieldDesignChange = fdc.Create
export const EditFieldDesignChange = fdc.Edit
export const RemoveRestoreFieldDesignChange = fdc.RemoveRestore

export const EditFieldDesignChangeResolution = new BasicPermissionItem({
  id: 'd857fde7-4586-49ad-8f05-bccebb664a0c',
  name: `Edit ${object} Resolution`,
  page,
  action: `edit the ${object.toLowerCase()} resolution. Users with Edit ${object} do not need this permission`,
  allowMixedCase: true,
})

export const RevertFieldDesignChange = Revert({
  id: 'fa987396-35ba-4ad5-8ba7-5ffb91111715',
  page,
  object,
})

export const UnlockFieldDesignChange = Unlock({
  id: '74ef6e10-c80e-4412-9c9f-f20a79915c35',
  page,
  object,
})

export const CommentOnFieldDesignChange = Simple({
  id: '02d65f90-a130-4b4e-811b-56ccc28deefd',
  action: 'Comment on',
  page,
  object,
})

export type FDCTrackerPermission =
  | typeof ViewFieldDesignChange
  | typeof CreateFieldDesignChange
  | typeof EditFieldDesignChange
  | typeof RemoveRestoreFieldDesignChange
  | typeof EditFieldDesignChangeResolution
  | typeof RevertFieldDesignChange
  | typeof UnlockFieldDesignChange
  | typeof CommentOnFieldDesignChange
